import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';


export const createWeekoff = createAsyncThunk(
    'weekoff/createweekoff',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/weekoff', data);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );
export const fetchAllWeekoff = createAsyncThunk(
    'weekoff/fetchweekoff',
    async (_, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get('/weekoff');         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );
export const UpdateWeekoff = createAsyncThunk(
    'weekoff/updateweekoff',
    async ( {Id , data} : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/weekoff/${Id}`, data);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create weekoff');
      }
    }
  );
export const GetWeekoffById = createAsyncThunk(
    'weekoff/GEtweekoff',
    async ( Id : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get(`/weekoff/${Id}`);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to get weekoff');
      }
    }
  );
export const deleteWeekoff = createAsyncThunk(
    'weekoff/deleteweekoff',
    async ( Id : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.delete(`/weekoff/${Id}`);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to delete weekoff');
      }
    }
  );